(() => {
  const shopifyQueryPattern = /^tag:"mpn:([^"]+)" OR variants\.sku:"([^"]+)" OR variants\.barcode:"([^"]+)"$/;

  function tagValue(value) {
    if (/^[\p{L}\p{N}._+\-/]+$/u.test(value)) return value;
    const bytes = new TextEncoder().encode(value);
    let binary = '';
    bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
    return `b64:${btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')}`;
  }

  function displayValue(value) {
    const match = value.match(shopifyQueryPattern);
    if (!match || match[2] !== match[3] || match[1] !== tagValue(match[2])) return null;
    return match[2];
  }

  function partNumber(value) {
    const original = value.trim();
    if (displayValue(original)) return null;
    const normalized = original.replace(/^\*+/, '').trim();
    const explicitMpn = original.startsWith('*');
    if (normalized.length < 3 || normalized.length > 120) return null;
    if (!explicitMpn && !/\d/.test(normalized)) return null;
    if (/[\u0000-\u001f\u007f"\\]/u.test(normalized)) return null;
    const structuredIdentifier = /[-./+]/.test(normalized) || /^ART-/i.test(normalized);
    return explicitMpn || structuredIdentifier ? normalized : null;
  }

  function shopifyQuery(value) {
    return `tag:"mpn:${tagValue(value)}" OR variants.sku:"${value}" OR variants.barcode:"${value}"`;
  }

  function restoreFriendlyInputs() {
    const query = new URLSearchParams(window.location.search).get('q') || '';
    const friendly = displayValue(query);
    if (!friendly) return;
    document.querySelectorAll('form[role="search"] input[name="q"]')
      .forEach((input) => {
        if (input.value !== friendly) input.value = friendly;
      });
    document.querySelectorAll('[data-part-number-search-display]')
      .forEach((element) => {
        if (element.textContent.includes(query)) {
          element.textContent = element.textContent.replace(query, friendly);
        }
      });
    if (document.title.includes(query)) document.title = document.title.replace(query, friendly);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form[role="search"]');
    const input = form?.querySelector('input[name="q"]');
    if (!input) return;
    const normalized = partNumber(input.value);
    if (normalized) input.value = shopifyQuery(normalized);
  }, true);

  restoreFriendlyInputs();
  document.addEventListener('DOMContentLoaded', restoreFriendlyInputs, { once: true });
  const currentQuery = new URLSearchParams(window.location.search).get('q') || '';
  if (displayValue(currentQuery)) {
    let restoreScheduled = false;
    new MutationObserver(() => {
      if (restoreScheduled) return;
      restoreScheduled = true;
      window.setTimeout(() => {
        restoreScheduled = false;
        restoreFriendlyInputs();
      }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
